var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrash = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#FF0D0D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M1 3.757h14.457M6.942 1.474h2.572c.966 0 1.758.784 1.758 1.758v.525H5.185v-.525c0-.966.783-1.758 1.757-1.758M8.229 6.8v9.131M5.185 6.8v9.131M11.272 6.8v9.131M11.386 18.975H5.071a2.283 2.283 0 0 1-2.283-2.169L2.142 3.757h12.174l-.655 13.049a2.283 2.283 0 0 1-2.282 2.168z"
})));
export default SvgTrash;